"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    iconSizeSmall: '34px',
    iconSizeMedium: '40px',
    iconSizeLarge: '46px',
    iconSizeHuge: '52px'
};
